import React from 'react'
import Button from 'shared/components/Button'

function FileUpload({ label = 'Upload file', accept, onChange }) {
  const fileInputRef = React.useRef(null)

  const handleButtonClick = () => {
    fileInputRef.current.click()
  }

  const [selectedFile, setSelectedFile] = React.useState(null)

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      onChange && onChange(file)
      setSelectedFile(file)
    }
  }

  function onClear(e) {
    fileInputRef.current.value = ''
    setSelectedFile(null)
    onChange && onChange(null)
  }

  return (
    <div className="flex items-center w-[75%]">
      <Button rounded size="small" onClick={selectedFile ? onClear : handleButtonClick}>
        {selectedFile ? 'Remove file' : label}
      </Button>
      <input
        ref={fileInputRef}
        className="file-upload"
        type="file"
        onChange={handleFileChange}
        hidden
        {...(accept ? { accept } : {})}
      />

      <div className="text-[14px] ml-[16px] opacity-40 max-w-[100%] truncate-end pr-[16px]">{selectedFile ? selectedFile.name : 'No file selected'}</div>
     
    </div>
  )
}

export default FileUpload
